import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosCometinhaPassagens = {
    ...dadosAgenciaComum,
    id: 'cometinhapassagens',
    nome: 'Cometinha Passagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-KPNCTH7']
};
